module.exports = __webpack_public_path__ + "img/login_ui.d699136b.png";